import React from 'react'
import { useTranslation } from 'react-i18next'
import { StyledLink } from './StyledComponents'

const CaseStudyTab = (props) => {
  const { t } = useTranslation()

  return (
    <div className='container'>
      <div className='custom-tab'>
        <ul className='list-unstyled'>
          <StyledLink href="/case-study">
            <li className={props.allCaseStudiesActive ? "active" : ""}>
              {t('case-study-tab.all-case-studies')}
            </li>
          </StyledLink>
          <StyledLink href="/case-study/document-security">
            <li className={props.documentSecurityActive ? "active" : ""}>
              {t('case-study-tab.document-security')}</li>
          </StyledLink>
          <StyledLink href="/case-study/education">
            <li className={props.educationActive ? "active" : ""}>
              {t('case-study-tab.education')}</li>
          </StyledLink>
        </ul>
      </div>
    </div>
  )
}

export default CaseStudyTab